import { InventoryNavItem } from 'src/pages/ClinicalTrial/Readings/ReadingInventory/InventoryNavItem';
import { readingInventorySubRoutes } from '@router/Readings.routes';
import { useMemo } from 'react';

export const ReadingInventoryNav = () => {
  const items = useMemo(
    () =>
      readingInventorySubRoutes.map(item => (
        <InventoryNavItem key={item.path} path={item.path} title={item.title as string} />
      )),
    []
  );
  return (
    <div
      className={
        'flex flex-col gap-1 py-2 bg-blueTone h-full rounded-[1.2rem] me-4'
      }
    >
      {items}
    </div>
  );
};
